/**
 * Folds dynamic route segments back to their pattern (`/referral/[code]`, not `/referral/ABC123`):
 * a referral code resolves to a specific user, and an anonymous event must carry no identifiers.
 * Compared whole-segment so a param value can't partially match inside another segment; an array
 * param (catch-all route) folds each of its segments.
 */
export function toRoutePath(pathname: string, params: Record<string, string | string[] | undefined>): string {
  const segmentToParamName = new Map(
    Object.entries(params).flatMap(([name, value]) => {
      if (typeof value === 'string') {
        return [[value, `[${name}]`] as const]
      }
      return (value ?? []).map((segment) => [segment, `[${name}]`] as const)
    })
  )
  // The pathname keeps percent-encoding while `params` values arrive decoded, so segments are
  // decoded before lookup, otherwise an encoded character in a param value defeats the fold and
  // the raw value rides the event after all.
  return pathname
    .split('/')
    .map((segment) => segmentToParamName.get(decodeSegment(segment)) ?? segment)
    .join('/')
}

function decodeSegment(segment: string): string {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}
